import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apps-admin',
  templateUrl: './apps.admin.component.pug',
  styleUrls: ['./apps.admin.component.sass']
})
export class AppsAdminComponent implements OnInit {
  constructor(
  ) {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/apps/admin/apps.admin.component.ts